import { connect } from 'react-redux';
import NoteEditorModal from './NoteEditorModal';
import { createNote } from '../../redux';

export default connect(null, { saveNote: createNote })(NoteEditorModal);
